"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLastTypingAt;

var _WebChatReduxContext = require("../WebChatReduxContext");

var showDeprecationNotes;

function useLastTypingAt() {
  if (!showDeprecationNotes) {
    console.warn('botframework-webchat: "useLastTypingAt" is deprecated. Please use "useActiveTyping" instead. They will be removed on or after 2022-02-16.');
    showDeprecationNotes = true;
  }

  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var lastTypingAt = _ref.lastTypingAt;
    return lastTypingAt;
  })];
}